import { formatDate } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgForm } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { faCheck, faPlusCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { forkJoin, Subscription } from 'rxjs';
import { ErrorService } from '../../../../../@core/utils/error.service';
import { Room } from '../../../models/storage/room';
import { RoomCustomAttrabute } from '../../../models/storage/room-custom-attrabute';
import { RoomDetail } from '../../../models/storage/room-detail';
import { RoomStatus } from '../../../models/storage/roomStatus';
import { RoomService } from '../../../services/storage/room-service';
import { WarehouseService } from '../../../services/storage/warehouse-service';
import { KwFilterDropdownService } from '../../../widgets/kw-filter-dropdown/kw-filter-dropdown.service';
import { FilterSettings } from '../../../widgets/kw-filter-dropdown/models/filter-options';
import { RoomEditPopupComponent } from '../room-edit-popup/room-edit-popup.component';
import { RoomsListTableDataSource } from './rooms-list-table-datasource';

@Component({
  selector: 'rooms-list-table',
  templateUrl: './rooms-list-table.component.html',
  styleUrls: ['./rooms-list-table.component.css']
})
export class RoomsListTableComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  dataSource: RoomsListTableDataSource;
  public faPlusCircle = faPlusCircle;
  private destroyRef = inject(DestroyRef);
  public editRoom: Room = {};
  public roomId: number;
  public roomLoading = true;
  private initialLoad = true;
  public submitting: any;
  public filteredDetails: RoomCustomAttrabute[] = [];
  public newRoomDetail: RoomDetail[] = [];
  public roomList: Room[] = [];
  private bottomSheetSubscription: Subscription;
  public statuses: RoomStatus[] = [];
  // public editWarehouse: Warehouse;

  public faTimes = faTimes;
  public faCheck = faCheck;


  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['id', 'name', 'roomDescription', 'roomCapacity', 'warehouse','barcode',  'integrationId', 'status'];
  defaultColumns = ['id', 'name', 'roomDescription', 'roomCapacity', 'warehouse', 'barcode', 'integrationId', 'status'];

  public filterSettings: FilterSettings = {
    roomSettings: {
      display: true,
      singleSelection: false
    },

  };
    get gridMessageAndCount() {
    // let pageSize = (this.grid && this.grid.pageSettings) ? this.grid.pageSettings.pageSize: 0;
    // let totalCount = (this.grid && this.grid.pageSettings) ? this.grid.pageSettings.totalRecordsCount: 0;
    // let currentPage = (this.grid && this.grid.pageSettings) ? this.grid.pageSettings.currentPage : 1;

    // let currentPageCount = 0 
    // if (pageSize && totalCount) {
    //   let remaining = totalCount - ((currentPage - 1) * pageSize);
    //   currentPageCount = remaining > pageSize ? pageSize : (remaining > 0 ? remaining : 0);
    // }
    return {
      message: "Narrow results by Room ."
      // count: currentPageCount,
      // showPdf:false,
      // showExcel:false,
      // pageSize: pageSize,
      // totalCount: totalCount
    };
  }

  constructor(
    private errorService: ErrorService,
    public service: RoomService,
    private changeDetRef: ChangeDetectorRef,
    private bottomSheet: MatBottomSheet,
    public warehouseService: WarehouseService,
    public filterService: KwFilterDropdownService
  ) { }

  ngOnInit() {
    this.roomLoading = true;
    this.dataSource = new RoomsListTableDataSource(this.paginator, this.sort);
    
    this.updateRooms();
  }

  updateRooms(){
    this.roomLoading = true;
    forkJoin([
      this.service.getRooms(true),
      this.service.getRoomStatuses()
    ]).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:data => {
      this.statuses = data[1];
      this.service.getCustomAttributes().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(attrs => {
        this.filteredDetails = attrs;
        this.newRoomDetail = attrs.map(attr => {
          return <RoomDetail>{
            id: 0,
            value: "",
            isActive: true,
            roomId: this.editRoom.id,
            roomCustomAttributeId: attr.id,
            roomCustomAttribute: attr
          }
        });

        this.editRoom.details = [...this.newRoomDetail];

        this.displayedColumns = [...this.defaultColumns]

        for (let x of this.filteredDetails) {
          this.displayedColumns.push(x.name.toString());
        }

        this.displayedColumns.push('isActive');
        this.displayedColumns.push('edit');

        this.roomList = data[0];
        this.dataSource.data = [...this.roomList];
        this.changeDetRef.markForCheck();
        this.roomLoading = false;
        this.paginator._changePageSize(this.paginator.pageSize);
      });
    },error: err => { this.errorService.handleError(err); this.roomLoading = false; }});
  }

  editClicked(id: number) {
    this.editRoom = { ...this.dataSource.data.filter(u => u.id === id)[0] };
    this.bottomSheet.open(RoomEditPopupComponent, {
      panelClass: 'bottomsheet-60-width', data: {
        room: {...this.editRoom}
      }
    });

    this.bottomSheetSubscription = this.bottomSheet._openedBottomSheetRef.afterDismissed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.updateRooms();
      this.bottomSheetSubscription.unsubscribe();
    });
  }

  getStatus(row: Room){
    let status = this.statuses.find(x => x.id == row.statusId)
    if(status)
      return status.value
    else return "";
  }

  addRoomClicked() {
    this.editRoom = {};
    this.editRoom.details = this.newRoomDetail;
    this.editRoom.isActive = true;
    this.bottomSheet.open(RoomEditPopupComponent, {
      panelClass: ['bottomsheet-60-width', 'custom-bottomsheet'], data: {
        room: {...this.editRoom}
      }
    });

    this.bottomSheetSubscription = this.bottomSheet._openedBottomSheetRef.afterDismissed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.updateRooms();
      this.bottomSheetSubscription.unsubscribe();
    });
  }

  deleteRoomClicked(form: NgForm) {
    this.roomLoading = true;
    if (this.editRoom.id !== null && this.editRoom.id !== undefined) {
      this.service.deleteRoom(this.editRoom.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
        // Keep the filter dropdown cache in sync so other pages drop the deleted room immediately
        this.filterService.removeCached('room', this.editRoom.id);
        this.roomList = this.dataSource.data.filter(x => x.id != this.editRoom.id);
        this.dataSource.data = this.dataSource.data.filter(x => x.id != this.editRoom.id);
        this.paginator._changePageSize(this.paginator.pageSize)
        this.editRoom = {};
        this.roomLoading = false;
        form.resetForm();
      }, error:err => { this.errorService.handleError(err); this.roomLoading = false; form.resetForm(); }});
    }
    else {
      alert("No Room Selected!!");
      this.roomLoading = false;
      form.resetForm();
    }
  }

  saveRoomClicked(form: NgForm) {
    this.roomLoading = true;
    if (this.editRoom.isActive === null || this.editRoom.isActive === undefined) { this.editRoom.isActive = false; };
    if (this.editRoom.id !== null && this.editRoom.id !== undefined) {
      this.editRoom.updatedDate = new Date;
      let index = this.dataSource.data.indexOf(this.dataSource.data.filter(w => w.id === this.editRoom.id)[0]);
      this.service.putRoom(this.editRoom).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
        this.filterService.upsertCached('room', this.editRoom);
        this.dataSource.data[index] = this.editRoom;
        this.dataSource.data = [...this.dataSource.data];
        this.paginator._changePageSize(this.paginator.pageSize);
        this.editRoom = {};
        this.roomLoading = false;
        form.resetForm();
      }, error:err => { this.errorService.handleError(err); this.roomLoading = false; form.resetForm(); }});
    }
    else {
      this.editRoom.id = 0;
      this.editRoom.createdDate = new Date();
      this.editRoom.updatedDate = this.editRoom.createdDate;
      this.editRoom.locations = [];
      this.service.postRoom(this.editRoom).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
        // this.editRoom.warehouse = this.editWarehouse;
        this.filterService.upsertCached('room', x);
        this.roomList.push(JSON.parse(JSON.stringify(x)));
        this.dataSource.data = [...this.roomList];
        this.paginator._changePageSize(this.paginator.pageSize);
        this.editRoom = {};
        this.roomLoading = false;
        form.resetForm();
      },error: err => { this.errorService.handleError(err); this.roomLoading = false; form.resetForm(); }});
    }
  }

  cancelClicked(form: NgForm) {
    this.editRoom = {};
    this.getCustomAttributes();
    form.resetForm();
  }


  getValue(row: Room, attrId: number) {
    if (!row || !row.details || !row.details.length) {
    return '';
    }

    let detail = row.details.find(function(x) {
      return x.roomCustomAttributeId == attrId;
    });

    if (!detail) {
      return '';
    }

    if (detail.roomCustomAttribute &&
        detail.roomCustomAttribute.datatype == "date" &&
        detail.value) {

      return formatDate(detail.value, 'MM/dd/yyyy', 'en-US');
    }

    return detail.value || '';
  }

  clearDetailValue(typeId: number) {
    this.editRoom.details.find(x => x.roomCustomAttribute.id === typeId).value = "";
  }

  getDetailName(row: Room, attrId: number) {
    return row.details.find(x => x.id == attrId).roomCustomAttribute.name
  }

  getCustomAttributes() {
    this.service.getCustomAttributes().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(attrs => {
      this.filteredDetails = attrs;
      this.newRoomDetail = attrs.map(attr => {
        return <RoomDetail>{
          id: 0,
          value: "",
          isActive: true,
          roomId: this.editRoom.id,
          roomCustomAttributeId: attr.id,
          roomCustomAttribute: attr
        }
      });

      this.editRoom.details = [...this.newRoomDetail];
    });
  }

  search(event) {
    if(this.initialLoad){
      this.initialLoad = false;
      event = this.filterService.getFilterState();
    }
    let results = this.roomList.filter(x => 
      (event.selectedRooms.map(y => y.id).includes(x.id) || event.selectedRooms.length == 0)  
   );
    
    this.dataSource.data = results;
    this.paginator._changePageSize(this.paginator.pageSize);
  }
}
